import React, { memo, useMemo } from 'react';
import TableCell from './TableCell';
import CellContent from './CellContent';
import { useScorecardContext } from '@/creditflowresearch/application/League/Scorecard/ScorecardContext';
import { IPeriod } from '@/creditflowresearch/domain/vo/League/IStandings';

interface IProps {
  hasAmount: boolean,
  periods: IPeriod[],
  rowIndex: number,
  categoryId?: string,
  subCategoryId?: string,
}

const TableRow = ({ periods, rowIndex, categoryId = null, subCategoryId = null, hasAmount = true }:IProps) => {
  const { state: { columnState, expandedCategories } } = useScorecardContext();
  const isVisible = subCategoryId ? expandedCategories.includes(categoryId) : true;
  const { valueTableIndex: index, valueTableColumnCount: count } = columnState;
  const sliceOfPeriods = useMemo(() => periods.slice(index, count + index), [periods, index, count]);

  const colSpan = sliceOfPeriods.length === 1 ? 3 : 1;

  if (!isVisible) {
    return null;
  }

  return (
    <tr data-test={ `row[${ rowIndex }]` }>
      { colSpan === 1 && <td /> }
      {
        sliceOfPeriods.map((period) => (
          <TableCell
            key={ period.name }
            name={ period.name }
            rowIndex={ rowIndex }
            rowData={ { ...period, categoryId, subCategoryId, hasAmount } }
            colSpan={ colSpan }
            cellCallback={ CellContent }
          />
        ))
      }
      { colSpan === 1 && <td /> }
    </tr>
  );
};

export default memo(TableRow);
